// Leads from areas with no client (public.dashboard_uncovered_leads, rnrinfra 20261012030000_uncovered_leads): real
// leads from places no active client serves, grouped by area, with each active client's service circle for the map.
// Admins and super admins. No names or contact details.
import {csvCell} from './inventory-export';

export type Basis='lead_zip'|'website_area'|'none';
export interface UncoveredArea {
 area:string;state:string|null;lat:number|null;lon:number|null;
 leads:number;leads_30d:number;leads_7d:number;calls:number;forms:number;last_lead_at:string|null;
 nearest_client:string|null;miles_outside:number|null;websites:string[]|null;
}
export interface UncoveredLead {
 id:number;received_at:string;area:string;website:string|null;channel:'call'|'form';basis:Basis;
 nearest_client:string|null;miles_outside:number|null;
}
export interface ServiceCircle {client:string;label:string|null;lat:number;lon:number;radius:number}
export interface UncoveredData {
 days:number;generated_at:string;
 totals:{leads:number;uncovered:number;uncovered_30d:number;areas:number;placed_by_zip:number;placed_by_website:number;not_placed:number};
 areas:UncoveredArea[];clients:ServiceCircle[];leads:UncoveredLead[];
}

export const BASIS_LABELS:Record<Basis,string>={lead_zip:'Lead’s ZIP',website_area:'Website’s area',none:'Not placed'};

/** "86 miles beyond Birmingham Drain Pros", or why there is no nearest client. */
export function nearestText(x:Pick<UncoveredArea,'nearest_client'|'miles_outside'>):string{
 if(!x.nearest_client)return 'No client to compare';
 const miles=Math.max(0,Math.round(x.miles_outside??0));
 return `${miles.toLocaleString('en-US')} mile${miles===1?'':'s'} beyond ${x.nearest_client}`;
}

/** Share of a period's real leads that came from areas with no client, as a whole percent. */
export const uncoveredShare=(t:UncoveredData['totals'])=>t.leads>0?Math.round(100*t.uncovered/t.leads):0;

/** Dot radius on the map: grows with the square root of the leads, so area tracks the count. */
export const dotRadius=(leads:number,max:number)=>max>0?4+16*Math.sqrt(Math.max(0,leads)/max):4;

/** Miles to the angle d3-geo's geoCircle takes. */
export const milesToDegrees=(miles:number)=>miles/3958.7613*180/Math.PI;

/** Areas that match a search over the area, state, websites and nearest client. */
export function matchArea(a:UncoveredArea,q:string):boolean{
 const t=q.trim().toLowerCase();
 if(!t)return true;
 return [a.area,a.state,a.nearest_client,...(a.websites??[])].some(v=>(v??'').toLowerCase().includes(t));
}

export function areasCsv(areas:UncoveredArea[],days:number):string{
 const head=['Area','State',`Leads (${days} days)`,'Last 30 days','Last 7 days','Calls','Forms','Nearest client','Miles beyond their area','Websites','Last lead'];
 const rows=areas.map(a=>[a.area,a.state??'',a.leads,a.leads_30d,a.leads_7d,a.calls,a.forms,a.nearest_client??'',a.miles_outside??'',(a.websites??[]).join(' '),a.last_lead_at??'']);
 return [head,...rows].map(r=>r.map(csvCell).join(',')).join('\r\n');
}
